import React, { useMemo } from 'react';
import { RiPlaneLine } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import Mode from './Mode';

import { getModeId } from '@/utils/CommandUtils';

const Panel = ({ data: robots }) => {
  const modeId = useMemo(() => {
    return getModeId(robots[0].model.vehicle, 'STABILIZE');
  }, [robots]);

  return <Mode data={robots} modeId={modeId} desc="Manual control with attitude stabilization only" />;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Stabilize';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiPlaneLine;
Command.Panel = Panel;

export default Command;
